import { theme as antdTheme } from "antd";

/*
 * Design tokens shared with the approved theme-preview prototype.
 * Keep these in sync with theme-preview/index.html's CSS custom properties
 * if the palette changes.
 */
const light = {
  page: "#f9f9f7",
  surface: "#fcfcfb",
  surface2: "#f3f2ee",
  ink: "#0b0b0b",
  ink2: "#52514e",
  inkMuted: "#898781",
  border: "rgba(11,11,11,0.10)",
  accent: "#8a6a12",
  accentInk: "#ffffff",
  seriesSub: "#2a78d6",
  seriesBook: "#008300",
};

const dark = {
  page: "#0d0d0d",
  surface: "#1a1a19",
  surface2: "#232322",
  ink: "#ffffff",
  ink2: "#c3c2b7",
  inkMuted: "#898781",
  border: "rgba(255,255,255,0.10)",
  accent: "#e0b23e",
  accentInk: "#1a1500",
  seriesSub: "#3987e5",
  seriesBook: "#008300",
};

function buildTheme(t, isDark) {
  return {
    algorithm: isDark ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
    token: {
      colorPrimary: t.accent,
      colorInfo: t.accent,
      colorBgLayout: t.page,
      colorBgContainer: t.surface,
      colorBgElevated: t.surface,
      colorFillAlter: t.surface2,
      colorText: t.ink,
      colorTextSecondary: t.ink2,
      colorTextTertiary: t.inkMuted,
      colorTextDescription: t.inkMuted,
      colorBorder: t.border,
      colorBorderSecondary: t.border,
      borderRadius: 10,
      fontFamily:
        'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
      fontSize: 14,
    },
    components: {
      Layout: {
        siderBg: t.surface,
        headerBg: t.surface,
        bodyBg: t.page,
      },
      Menu: {
        colorItemBg: "transparent",
        colorSubItemBg: "transparent",
        colorItemText: t.ink2,
        colorItemTextHover: t.ink,
        colorItemTextSelected: t.ink,
        colorItemBgHover: t.surface2,
        colorItemBgSelected: isDark
          ? "rgba(224,178,62,0.16)"
          : "rgba(138,106,18,0.10)",
        itemBorderRadius: 8,
        radiusItem: 8,
        colorActiveBarWidth: 0,
        colorActiveBarBorderSize: 0,
      },
      Button: {
        colorPrimary: t.accent,
        primaryColor: t.accentInk,
        borderRadius: 8,
      },
      Input: {
        colorBgContainer: t.page,
        borderRadius: 8,
      },
      Select: {
        borderRadius: 8,
      },
      Table: {
        colorFillAlter: t.surface2,
        borderRadius: 8,
      },
      Card: {
        borderRadiusLG: 14,
      },
      Tabs: {
        colorBgContainer: "transparent",
        colorPrimary: t.accent,
      },
    },
  };
}

export const LIGHT_THEME = buildTheme(light, false);
export const DARK_THEME = buildTheme(dark, true);

export function getThemeConfig() {
  const pref = window.localStorage?.theme;
  return pref === "dark" ? DARK_THEME : LIGHT_THEME;
}

export function isDarkTheme() {
  return window.localStorage?.theme === "dark";
}

export function getChartColors() {
  const t = isDarkTheme() ? dark : light;
  return {
    surface: t.surface,
    grid: isDarkTheme() ? "#2c2c2a" : "#e1e0d9",
    baseline: isDarkTheme() ? "#383835" : "#c3c2b7",
    ink: t.ink,
    inkMuted: t.inkMuted,
    accent: t.accent,
    seriesSub: t.seriesSub,
    seriesBook: t.seriesBook,
  };
}
